// import { get, post, put, remove } from "./base";
import { get, post, patch, remove } from "./base";
import store from "../store";
import * as actions from "../store/actions/clients";

import url from "./url";
import objectToParams from "./params";
import queries from "./queries";

const { dispatch } = store;

async function searchClients({ id = "", params = {}, headers = {} } = {}) {
  try {
    const stringParams = objectToParams(params);
    const query = url(queries.clients, id);
    dispatch(actions.searchClientRequest(params.search));
    const response = await get(query + stringParams, headers);
    dispatch(actions.searchClientRequestSuccess(response));
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.searchClientRequestFailed(err));
  }
}

async function getClients({ id = "", params = {}, headers = {} } = {}) {
  try {
    const stringParams = objectToParams(params);
    const query = url(queries.clients, id);
    dispatch(actions.getClientsRequest());
    const response = await get(query + stringParams, headers);
    dispatch(
      actions.getClientsRequestSuccess(
        Array.isArray(response) ? response : [response]
      )
    );
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.getClientsRequestFailed(err));
  }
}

async function upgradeClient({
  id = "",
  params = {},
  data = {},
  headers = {}
} = {}) {
  try {
    const stringParams = objectToParams(params);
    const query = url(queries.clientsUpgrade, id);
    dispatch(actions.upgradeClientRequest());
    const response = await patch(query + stringParams, data, headers);
    dispatch(actions.upgradeClientRequestSuccess(response));

    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.upgradeClientRequestFailed(err));
  }
}

async function addClient({
  id = "",
  params = {},
  data = {},
  headers = {}
} = {}) {
  try {
    const stringParams = objectToParams(params);
    const query = url(queries.clients, id);
    dispatch(actions.addClientRequest(data));
    const response = await post(query + stringParams, data, headers);
    dispatch(actions.addClientRequestSuccess(response));

    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.getClientsRequestFailed(err));
  }
}

async function removeClient({
  id = "",
  params = {},
  data = {},
  headers = {}
} = {}) {
  try {
    const stringParams = objectToParams(params);
    const query = url(queries.clients, id);
    dispatch(actions.removeClientRequest());
    const response = await remove(query + stringParams, data, headers);
    dispatch(actions.removeClientRequestSuccess(id));

    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.removeClientRequestFailed(err));
  }
}

async function editClient({
  id = "",
  params = {},
  data = {},
  headers = {}
} = {}) {
  try {
    const stringParams = objectToParams(params);
    const query = url(queries.clients, id);
    dispatch(actions.editClientRequest());
    // const response = await put(query + stringParams, data, headers);
    const response = await patch(query + stringParams, data, headers);
    dispatch(actions.editClientRequestSuccess(response));

    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.editClientRequestFailed(err));
  }
}

async function getVerticals({ id = "", params = {} } = {}) {
  try {
    const query = url(queries.verticals, id);
    dispatch(actions.getVerticalsRequest());
    const response = await get(query, params);
    dispatch(actions.getVerticalsRequestSuccess(response));

    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.getVerticalsRequestFailed(err));
  }
}

export default class ClientsAPI {
  static get = getClients;

  static add = addClient;

  static edit = editClient;

  static upgrade = upgradeClient;

  static remove = removeClient;

  static search = searchClients;

  static vertical = getVerticals;
}
